"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var antd_1 = require("antd");
var slate_react_1 = require("slate-react");
var slate_1 = require("slate");
function VideoModal(props) {
  var _a = react_1.useState(''),
    url = _a[0],
    setUrl = _a[1];
  var _b = react_1.useState(''),
    videoId = _b[0],
    setVideoId = _b[1];
  var _c = react_1.useState(''),
    error = _c[0],
    setError = _c[1];
  var _d = react_1.useState(false),
    isShort = _d[0],
    setIsShort = _d[1];
  var editor = slate_react_1.useSlate();
  var visible = props.visible,
    onCancel = props.onCancel;
  var parseId = react_1.useCallback(function (url) {
    var match;
    var shortReg = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(shorts\/))([^\/#&?]*).*/;
    if (shortReg.test(url)) {
      match = url.match(shortReg);
      setIsShort(true);
      return match && match[6].length === 11 ? match[6] : '';
    }
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    match = url.match(regExp);
    setIsShort(false);
    return match && match[7].length === 11 ? match[7] : '';
  }, []);
  function insertYoutubeVideo(videoId) {
    var text = {
      text: ''
    };
    var video = __assign({
      type: 'youtube',
      src: "https://www.youtube.com/embed/" + videoId,
      children: [text]
    }, isShort ? {
      short: true,
      width: 315,
      height: 560,
      display: 'block',
      position: 'static'
    } : {});
    slate_1.Transforms.select(editor, editor._onBlurSelection);
    slate_1.Transforms.insertNodes(editor, video);
    // workaround, let user can select pure text rather than the image block
    var emptyTextNode = {
      type: 'p',
      children: [{
        text: ''
      }]
    };
    slate_1.Transforms.insertNodes(editor, emptyTextNode);
  }
  return react_1.default.createElement(antd_1.Modal, {
    className: "custom-modal",
    title: "\u65B0\u589EYoutube\u5F71\u7247",
    visible: visible,
    bodyStyle: {
      padding: 20
    },
    onCancel: onCancel,
    onOk: function () {
      onCancel();
      insertYoutubeVideo(videoId);
      setVideoId('');
      setUrl('');
      setError('');
    },
    okText: "\u78BA\u5B9A",
    cancelText: "\u53D6\u6D88"
  }, react_1.default.createElement("label", null, "\u5B8C\u6574\u7DB2\u5740"), react_1.default.createElement(antd_1.Input, {
    placeholder: "\u586B\u5165\u5B8C\u6574url: https://www.youtube.com/watch?v=123....",
    value: url,
    onChange: function (e) {
      return setUrl(e.target.value);
    },
    onBlur: function () {
      return setVideoId(parseId(url));
    },
    style: {
      width: '100%',
      marginBottom: 10
    }
  }), react_1.default.createElement("code", {
    style: {
      backgroundColor: '#eee'
    }
  }, isShort ? 'https://www.youtube.com/shorts/' : 'https://www.youtube.com/watch?v='), react_1.default.createElement("code", {
    style: {
      backgroundColor: '#ddd'
    }
  }, videoId), react_1.default.createElement("div", {
    style: {
      color: 'red'
    }
  }, error));
}
exports.default = VideoModal;